module.exports = __webpack_public_path__ + "img/arrow-right.20b745bb.svg";